import { createContext } from 'react';
import type { PlatoUserMe } from '../../../utils/plato-user.ts';

// this should be away from the plato-user-layout component, so it doesn't get
// recreated on HMR
export const PlatoUserContext = createContext<PlatoUserMe | undefined>(undefined);
